import { createBasicSelector } from 'util/redux'
import selectBase from '../selectBase'

const selectItemsById = createBasicSelector(selectBase, base => base.itemsById)

export default selectItemsById
